import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { Button } from '@naf-simba/elements-buttons';
import { simbaStyled } from '@naf-simba/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.space16};
  margin: -${spacing.space20} 0 ${spacing.space40};

  @media screen and (max-width: ${breakpoints.m}) {
    margin: -${spacing.space32} 0 ${spacing.space40};
  }
`;

export const LoginButton = simbaStyled(Button)(() => ({
  '&&': {
    alignSelf: 'flex-start',
  },
}));
